import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/Booking.css";
import api from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import ImportantToKnow from "../components/ImportantToKnow";

function Booking() {
  const navigate = useNavigate();
  const { language ,t } = useLanguage();

  // ============================================================
  // LANGUAGE
  // ============================================================

  const getLanguageId = () => {
    if (
      typeof language === "number" ||
      !isNaN(Number(language))
    ) {
      return Number(language);
    }

    if (language && typeof language === "object") {
      return (
        Number(
          language.lang_id ||
            language.language_id ||
            language.id
        ) || 1
      );
    }

    return 1;
  };

  const languageId = getLanguageId();
  // ============================================================
  // TODAY
  // ============================================================

  const getToday = () => {
    const date = new Date();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const today = getToday();


  
  // ============================================================
  // LOCATIONS
  // ============================================================

  const [locations, setLocations] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(true);
  const [showRegularClientLogin, setShowRegularClientLogin] = useState(false);  // code-1416

  // ============================================================
  // BOOKING FORM
  // ============================================================

  const [bookingData, setBookingData] = useState({
    cmbPickLocation: "",
    pickdate: "",
    cmbpickHour: "",
    cmbpickmin: "",
    cmbDropLocation: "",
    returndate: "",
    cmbreturnHour: "",
    cmbreturnmin: "",

    clientid: "",
    clientemail: "",
  });

  // ============================================================
  // GET LOCATIONS
  // ============================================================

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setLoadingLocations(true);

        console.log(
          "================================================"
        );
        console.log("BOOKING LOCATION LANGUAGE:", languageId);
        console.log(
          "GETTING LOCATIONS: /locations/getLocations"
        );

        const response = await api.get(
          "/locations/getLocations",
          {
            params: {
              city_id: 1,
              lang_id: languageId,
            },
          }
        );

        console.log(
          "BOOKING LOCATIONS RESPONSE:",
          response.data
        );

        const result = response.data;

        let locationData = [];

        if (
          result?.success &&
          Array.isArray(result.data)
        ) {
          locationData = result.data;
        } else if (Array.isArray(result)) {
          locationData = result;
        } else if (
          Array.isArray(result?.data)
        ) {
          locationData = result.data;
        }

        console.log(
          "FINAL LOCATION ARRAY:",
          locationData
        );

        if (locationData.length > 0) {
          console.log(
            "FIRST LOCATION OBJECT:",
            locationData[0]
          );

          console.table(locationData);
        }

        setLocations(locationData);
      } catch (error) {
        console.error(
          "ERROR FETCHING BOOKING LOCATIONS:",
          error
        );

        setLocations([]);
      } finally {
        setLoadingLocations(false);
      }
    };

    fetchLocations();
  }, [languageId]);

  // ============================================================
  // FALLBACK LOCATIONS
  // ============================================================

  const defaultLocations = [
    {
      location_id: 30,
      id: 30,
      name: "Airport Heraklion",
      location_name: "Airport Heraklion",
    },
    {
      location_id: 29,
      id: 29,
      name: "Airport Chania",
      location_name: "Airport Chania",
    },
    {
      location_id: 28,
      id: 28,
      name: "Airport Sitia",
      location_name: "Airport Sitia",
    },
    {
      location_id: 27,
      id: 27,
      name: "Harbour Heraklion",
      location_name: "Harbour Heraklion",
    },
    {
      location_id: 26,
      id: 26,
      name: "Harbour Chania",
      location_name: "Harbour Chania",
    },
    {
      location_id: 25,
      id: 25,
      name: "Harbour Sitia",
      location_name: "Harbour Sitia",
    },
    {
      location_id: 24,
      id: 24,
      name:
        "Accommodation (apartment, villa, hotel etc.)",
      location_name:
        "Accommodation (apartment, villa, hotel etc.)",
    },
  ];

  const locationList =
    locations.length > 0
      ? locations
      : defaultLocations;

  // ============================================================
  // LOCATION ID
  // IMPORTANT:
  // DO NOT USE city_id HERE.
  // city_id = city, not pickup/drop location.
  // ============================================================

  const getLocationId = (location) => {
    const id =
      location?.location_id ??
      location?.locationid ??
      location?.loc_id ??
      location?.locationId ??
      location?.id ??
      "";

    return id === null ||
      id === undefined ||
      id === ""
      ? ""
      : String(id);
  };

  // ============================================================
  // LOCATION NAME
  // ============================================================

  const getLocationName = (location) => {
    return (
      location?.location_name ??
      location?.locationname ??
      location?.loc_name ??
      location?.locationName ??
      location?.name ??
      location?.title ??
      location?.location ??
      ""
    );
  };

  // ============================================================
  // HOURS / MINUTES
  // ============================================================

  const hours = Array.from(
    { length: 24 },
    (_, i) => String(i).padStart(2, "0")
  );

  const minutes = ["00", "15", "30", "45"];

  // ============================================================
  // CHANGE HANDLER
  // ============================================================

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    console.log("BOOKING FIELD CHANGED:", name, "=", value);
  
    setBookingData((prev) => {
      const updatedData = {
        ...prev,
        [name]: value,
      };
  
      // Pickup date changed
      if (name === "pickdate" && value) { 
        const date = new Date(value + "T00:00:00");
        // Automatic return = pickup + 3 days
        date.setDate(date.getDate() + 3);
        updatedData.returndate = date
          .toISOString()
          .split("T")[0];
      }
      return updatedData;
    });
  };
  

  // ============================================================
  // CONTINUE
  // ============================================================

  const handleContinue = (e) => {
    e.preventDefault();

    console.log(
      "================================================"
    );
    console.log("BOOKING DATA BEFORE VALIDATION:");
    console.log(bookingData);

    // ========================================================
    // BASIC VALIDATION
    // ========================================================

    if (!bookingData.cmbPickLocation) {
      alert("Please select pickup location.");
      return;
    }

    if (!bookingData.pickdate) {
      alert("Please select pickup date.");
      return;
    }

    if (
      !bookingData.cmbpickHour ||
      !bookingData.cmbpickmin
    ) {
      alert("Please select pickup time.");
      return;
    }

    if (!bookingData.cmbDropLocation) {
      alert("Please select return location.");
      return;
    }

    if (!bookingData.returndate) {
      alert("Please select return date.");
      return;
    }

    if (
      !bookingData.cmbreturnHour ||
      !bookingData.cmbreturnmin
    ) {
      alert("Please select return time.");
      return;
    }

    // ========================================================
    // FORCE LOCATION IDS TO STRING
    // ========================================================

    const pickupLocation = String(
      bookingData.cmbPickLocation
    );

    const dropLocation = String(
      bookingData.cmbDropLocation
    );

    // ========================================================
    // BOOKING CRITERIA
    // ========================================================

    const criteria = {
      cmbPickLocation: pickupLocation,

      pickdate: bookingData.pickdate,

      cmbpickHour: bookingData.cmbpickHour,

      cmbpickmin: bookingData.cmbpickmin,

      cmbDropLocation: dropLocation,

      returndate: bookingData.returndate,

      cmbreturnHour:
        bookingData.cmbreturnHour,

      cmbreturnmin:
        bookingData.cmbreturnmin,

      cmbcartype: "",
      cmbdrvage: "",

      clientid: bookingData.clientid,

      clientemail: bookingData.clientemail,

      selectedlanguage: languageId,
    };

    // ========================================================
    // DEBUG
    // ========================================================

    console.log(
      "================================================"
    );

    console.log(
      "PICKUP LOCATION ID:",
      criteria.cmbPickLocation
    );

    console.log(
      "RETURN LOCATION ID:",
      criteria.cmbDropLocation
    );

    console.log(
      "FINAL BOOKING CRITERIA:",
      criteria
    );

    // ========================================================
    // SAVE TO SESSION STORAGE
    // ========================================================

    try {
      sessionStorage.setItem(
        "bookingCriteria",
        JSON.stringify(criteria)
      );

      console.log(
        "BOOKING CRITERIA SAVED TO SESSION STORAGE"
      );

      console.log(
        "SESSION bookingCriteria:",
        sessionStorage.getItem(
          "bookingCriteria"
        )
      );
    } catch (storageError) {
      console.error(
        "ERROR SAVING BOOKING CRITERIA:",
        storageError
      );

      alert(
        "Unable to save booking details. Please try again."
      );

      return;
    }

    // ========================================================
    // NAVIGATE TO BOOKING PAGE
    // ========================================================

    console.log(
      "NAVIGATING TO /bookacar"
    );

    navigate("/bookacar");
  };

  // ============================================================
  // REGULAR CLIENT LOGIN
  // ============================================================

  const handleRegularLogin = (e) => {
    e.preventDefault();

    console.log(
      "Regular client login clicked"
    );

    // Keep this as link/button for now.
    // navigate("/regular-client-login");
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div className="booking-page">

      {/* ======================================================
          BOOKING ENGINE
      ====================================================== */}

      <div className="booking-engine-wrapper hero-wrap ftco-degree-bg">

        <div className="container">

          <div className="row no-gutters slider-text justify-content-start align-items-center justify-content-center booking-slider-row">

            <div className="col-lg-8 booking-engine-column">

              <div className="booking-engine-text">

                <div className="col-md-12 d-flex align-items-center">

                  <form
                    onSubmit={handleContinue}
                    className="request-form booking-request-form bg-primary"
                  >

                    {/* ==================================================
                        PICKUP INFORMATION
                    ================================================== */}

                    <div className="booking-half">

                      <div className="booking-label-row">
                        <label className="label">

                        {t("bookingengine.bookingengine0", "Pick-up Location")}
                        </label>
                      </div>

                      <div className="booking-full-row">

                        <div className="booking-full-field">

                          <div className="selectParent">

                            <select
                              className="arrow form-control select"
                              name="cmbPickLocation"
                              value={
                                bookingData.cmbPickLocation
                              }
                              onChange={handleChange}
                              disabled={
                                loadingLocations
                              }
                            >

                              <option value="">
                                {loadingLocations
                                  ? "Loading locations..."
                                  : t("bookingengine.bookingengine8", "Select location")}
                              </option>

                              {locationList.map(
                                (location, index) => {

                                  const locationId =
                                    getLocationId(
                                      location
                                    );

                                  const locationName =
                                    getLocationName(
                                      location
                                    );

                                  return (
                                    <option
                                      key={
                                        locationId ||
                                        index
                                      }
                                      value={
                                        locationId
                                      }
                                    >
                                      {locationName}
                                    </option>
                                  );
                                }
                              )}

                            </select>

                          </div>

                        </div>

                      </div>

                      {/* PICKUP DATE + TIME */}
                        <label className="label" style={{marginRight: "52px",float: "left"}}>
                            {t("bookingengine.bookingengine1", "Pick-up Date & Time")}
                          </label>
                      <div className="booking-full-row">

                        <div className="booking-date-field">

                          <div className="form-group">

                            <input
                              type="date"
                              className="calendar form-control"
                              name="pickdate"
                              min={today}
                              value={
                                bookingData.pickdate
                              }
                              onChange={
                                handleChange
                              }
                            />

                          </div>

                        </div>

                        <div className="booking-time-field">

                          <div className="time-select-wrapper">

                            <select
                              className="form-control arrow"
                              name="cmbpickHour"
                              value={
                                bookingData.cmbpickHour
                              }
                              onChange={
                                handleChange
                              }
                            >

                              <option value="">
                              {t("ratechart.ratechart17", "Hour")}
                              </option>

                              {hours.map(
                                (hour) => (
                                  <option
                                    key={hour}
                                    value={hour}
                                  >
                                    {hour}
                                  </option>
                                )
                              )}

                            </select>

                            <span className="time-colon">
                              :
                            </span>

                            <select
                              className="arrow form-control"
                              name="cmbpickmin"
                              value={
                                bookingData.cmbpickmin
                              }
                              onChange={
                                handleChange
                              }
                            >

                              <option value="">
                              {t("othersnewstatics.othersnewstatic46", "Min")}
                              </option>

                              {minutes.map(
                                (minute) => (
                                  <option
                                    key={minute}
                                    value={minute}
                                  >
                                    {minute}
                                  </option>
                                )
                              )}

                            </select>

                          </div>

                        </div>

                      </div>

                    </div>

                    {/* ==================================================
                        RETURN INFORMATION
                    ================================================== */}

                    <div className="booking-half">

                      <div className="booking-label-row">
                        
                         <label className="label">
                             {t("bookingengine.bookingengine3", "Drop-off Location")}
                          </label>
                      </div>

                      <div className="booking-full-row">

                        <div className="booking-full-field">

                          <div className="selectParent">

                            <select
                              className="arrow form-control select"
                              name="cmbDropLocation"
                              value={
                                bookingData.cmbDropLocation
                              }
                              onChange={
                                handleChange
                              }
                              disabled={
                                loadingLocations
                              }
                            >

                              <option value="">
                                {loadingLocations
                                  ? "Loading locations..."
                                  : t("bookingengine.bookingengine8", "Select location")}
                              </option>

                              {locationList.map(
                                (location, index) => {

                                  const locationId =
                                    getLocationId(
                                      location
                                    );

                                  const locationName =
                                    getLocationName(
                                      location
                                    );

                                  return (
                                    <option
                                      key={
                                        locationId ||
                                        index
                                      }
                                      value={
                                        locationId
                                      }
                                    >
                                      {locationName}
                                    </option>
                                  );
                                }
                              )}

                            </select>

                          </div>

                        </div>

                      </div>

                      {/* RETURN DATE + TIME */}
 <label className="label" style={{marginRight: "52px",float: "left"}}>
                            {t("bookingengine.bookingengine4", "Drop-off Date & Time")}
                          </label>
                      <div className="booking-full-row">

                        <div className="booking-date-field">

                        

                            <div className="form-group">

                              <input
                                type="date"
                                className="calendar form-control"
                                name="returndate"
                                value={
                                  bookingData.returndate
                                }
                                min={
                                  bookingData.pickdate || today
                                }
                                onChange={
                                  handleChange
                                }
                              />


                          </div>

                        </div>

                        <div className="booking-time-field">

                          <div className="time-select-wrapper">

                            <select
                              className="form-control arrow"
                              name="cmbreturnHour"
                              value={
                                bookingData.cmbreturnHour
                              }
                              onChange={
                                handleChange
                              }
                            >

                              <option value="">
                              {t("ratechart.ratechart17", "Hour")}
                              </option>

                              {hours.map(
                                (hour) => (
                                  <option
                                    key={hour}
                                    value={hour}
                                  >
                                    {hour}
                                  </option>
                                )
                              )}

                            </select>

                            <span className="time-colon">
                              :
                            </span>

                            <select
                              className="form-control arrow"
                              name="cmbreturnmin"
                              value={
                                bookingData.cmbreturnmin
                              }
                              onChange={
                                handleChange
                              }
                            >

                              <option value="">
                                {t("othersnewstatics.othersnewstatic46", "Min")}
                              </option>

                              {minutes.map(
                                (minute) => (
                                  <option
                                    key={minute}
                                    value={minute}
                                  >
                                    {minute}
                                  </option>
                                )
                              )}

                            </select>

                          </div>

                        </div>

                      </div>

                    </div>

                    {/* ==================================================
                        CONTINUE + REGULAR CLIENT LOGIN
                    ================================================== */}

                    <div className="booking-action-row">

                      <div className="booking-action-half">

                        <div className="form-group">

                          <input
                            type="submit"
                            value={`${t("bookingengine.bookingengine9", "Continue")}`}
                            className="btn btn-secondary1"
                          />

                        </div>

                      </div>

                      <div className="col-md-4 booking-action-half"
                       style={{
                        float: "right",
                        padding:
                          "0 5px 0 0",
                      }}
                      >
                        {/* code-1416 */}
                        <button
                            type="button"
                            className="btn btn-secondary2 py-3 px-4"
                            onClick={() => setShowRegularClientLogin((prev) => !prev)}
                          >
                         
                          {t("bookingengine.bookingengine24", "Regular client Login")}
                        </button>

                      </div>

                    </div>

                    {/* ==================================================
                        REGULAR CLIENT DETAILS  - code-1416
                    ================================================== */}
                    {showRegularClientLogin && (
                        <div className="booking-client-row">

                          {/* CLIENT ID */}

                          <div className="booking-client-half">

                            <div className="form-group">

                              <input
                                type="text"
                                name="clientid"
                                className="frmtxtbox1"
                                maxLength="30"
                                value={
                                  bookingData.clientid
                                }
                                onChange={
                                  handleChange
                                }
                                placeholder={`${t("bookingengine.bookingengine16", "Client Id.")} :`}
                              />

                              <label>
                                <span className="required-star">
                                  *
                                </span>
                                {t("othersnewstatics.othersnewstatic48", "When am I entitled to be a regular client")}?

                              </label>

                            </div>

                          </div>

                          {/* EMAIL */}

                          <div className="booking-client-half">

                            <div className="form-group">

                              <input
                                type="text"
                                name="clientemail"
                                className="frmtxtbox1"
                                maxLength="100"
                                value={
                                  bookingData.clientemail
                                }
                                onChange={
                                  handleChange
                                }
                                placeholder={`${t("bookingengine.bookingengine17", "Email Id.")} :`}
                              />

                              <label>
                                <span className="required-star">
                                  *
                                </span>
                                {t("othersnewstatics.othersnewstatic47", "I forgot my regular client ID")}?
                              </label>

                            </div>

                          </div>

                        </div>
                      )} 
                  </form>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* ======================================================
          EMPTY CONTENT AREA
      ====================================================== */}

      <div className="p20 booking-empty-area">

        <div className="container container2 p0">

          <div className="col-md-12 main-content">

            <div className="clearfix"></div>

          </div>

        </div>

      </div>

      {/* ======================================================
          IMPORTANT INFORMATION
      ====================================================== */}

    <ImportantToKnow />

    </div>
  );
}

export default Booking;